import { EmailTemplate, TestEmail } from './types';
import axiosInstance from '../../lib/api/axios';
import { getServerUrl } from '../../lib/utils';

export const getEmailTemplates = async (): Promise<EmailTemplate[]> => {
  const { data } = await axiosInstance.get(`${getServerUrl()}/emailTemplates`);
  return data;
};

export const getEmailTemplate = async (id: string): Promise<EmailTemplate> => {
  const { data } = await axiosInstance.get(`${getServerUrl()}/emailTemplates/${id}`);
  return data;
};

export const updateEmailTemplate = async (id: number, payload: EmailTemplate): Promise<EmailTemplate> => {
  const { data } = await axiosInstance.patch(`${getServerUrl()}/emailTemplates/${id}`, payload);
  return data;
};

export const getEmailTemplateHTML = async (id: number): Promise<string> => {
  const { data } = await axiosInstance.get(`${getServerUrl()}/emailTemplates/${id}/files`);
  return data;
};

export const updateEmailTemplateHTML = async (id: number, file: string): Promise<void> => {
  await axiosInstance.post(`${getServerUrl()}/emailTemplates/${id}/files`, { file: file });
};

export const sendTestEmail = async (id: number, payload: TestEmail): Promise<void> => {
  await axiosInstance.post(`${getServerUrl()}/emailTemplates/${id}/action/sendTest`, payload);
};
